import { filterOptions } from '@/utils/query-base'

const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
  'kotabnr': {
    title: '价格类型',
    type: 'select',
    equation: city,
    dictionary: 'A0101',
    unRA: true,
    clear: false
  }

}

export default {
  'product_id': {
    title: '产品编码',
    width: 180
  },
  'short_text': {
    title: '产品描述',
    width: 400
  },
  'zsalesunit_text': {
    title: '营销单元'
  },
  'sold_to_party': {
    title: '客户编号'
  },
  'zpric_type_text': {
    title: '价格类型'
  },
  'kbetr': {
    title: '价格金额'
  },
  'o_kbetr': {
    title: '老价格'
  },
  'o_from': {
    title: '老价格失效日期',
    width: 150
  },
  'create_date': {
    title: '创建时间'
  },
  'remark': {
    title: '备注'
  },
  'uname': {
    title: '批导人'
  },
  'datum': {
    title: '批导日期'
  }
}



// WEBPACK FOOTER //
// ./src/views/price-manage/config/priceBatchApprove.js